module.exports = __webpack_public_path__ + "static/media/gameIcon.292ae283.svg";